import * as React from "react";
import {
  Typography,
  Card,
  CardContent,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  TablePagination,
  IconButton,
  Tooltip,
} from "@mui/material";
import { useState, useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close"; // Optional for "Close" action button
import apiCall from "../../../../../API/apiService";
import apiEndpoints from "../../../../../API/apiEndpoints";
import CustomPagination from "../components/CustomPagination"; // Correct the path if necessary
import YourSVG from "../../../../../assets/svgComponent/scheduleinterview.svg";
import {
  Table as AntTable,
  Modal,
  message,
  Button as AntButton,
  Dropdown,
  Menu,
  Input as AntInput,
  Select,
  Space,
  Radio,
  Checkbox,
  List,
  Tag,
  Col,
} from "antd";
import {
  CopyOutlined,
  CloseOutlined,
  InfoCircleOutlined,
  MoreOutlined,
  EditOutlined,
  MessageOutlined,
  FilterOutlined,
  SearchOutlined,
  MailOutlined,
  CalendarOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";
import CancelSvg from "../../../../../assets/svgComponent/cancel.svg";
import SaveSvg from "../../../../../assets/svgComponent/save.svg";
import FilterSvg from "../../../../../assets/svgComponent/filter.svg";
import FilterAppliedSvg from "../../../../../assets/svgComponent/filtersign.svg";
import { toasty } from "../../../../../../Helper";

const saveFilterState = (filters, isApplied) => {
  localStorage.setItem(
    "applicantListFilters",
    JSON.stringify({
      filters,
      isFilterApplied: isApplied,
      statusFilter: filters.status || [],
      roundFilter: filters.round_no || "",
      ai_scoreFilter: filters.ai_score || "",
      experienceFilter: filters.experience || "",
      evaluationCriteriaFilter: filters.individual_score_filter || {},
      fromDateFilter: filters.created_at_from || "",
      toDateFilter: filters.created_at_to || "",
      completedFromDateFilter: filters.completed_from || "",
      completedToDateFilter: filters.completed_to || "",
    })
  );
};

const loadFilterState = () => {
  const savedState = localStorage.getItem("applicantListFilters");
  return savedState
    ? JSON.parse(savedState)
    : {
        filters: {},
        isFilterApplied: false,
        statusFilter: [],
        roundFilter: "",
        ai_scoreFilter: "",
        experienceFilter: "",
        evaluationCriteriaFilter: {},
        fromDateFilter: "",
        toDateFilter: "",
        completedFromDateFilter: "",
        completedToDateFilter: "",
      };
};

// Function to read URL parameters and convert them to filter state
const readUrlParameters = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const filters = {};
  let hasFilters = false;

  // Read status parameter
  const status = urlParams.get('status');
  if (status) {
    filters.status = [status];
    hasFilters = true;
  }

  // Read round_no parameter
  const roundNo = urlParams.get('round_no');
  if (roundNo) {
    filters.round_no = roundNo;
    hasFilters = true;
  }

  // Read ai_score parameter
  const aiScore = urlParams.get('ai_score');
  if (aiScore) {
    filters.ai_score = aiScore;
    hasFilters = true;
  }

  // Read experience parameter
  const experience = urlParams.get('experience');
  if (experience) {
    filters.experience = experience;
    hasFilters = true;
  }

  // Read individual_score_filter parameter
  const individualScoreFilter = urlParams.get('individual_score_filter');
  if (individualScoreFilter) {
    try {
      filters.individual_score_filter = JSON.parse(individualScoreFilter);
      hasFilters = true;
    } catch (error) {
      console.error("Error parsing individual_score_filter:", error);
    }
  }

  // Read created_at_from parameter
  const createdAtFrom = urlParams.get('created_at_from');
  if (createdAtFrom) {
    filters.created_at_from = createdAtFrom;
    hasFilters = true;
  }

  // Read created_at_to parameter
  const createdAtTo = urlParams.get('created_at_to');
  if (createdAtTo) {
    filters.created_at_to = createdAtTo;
    hasFilters = true;
  }

  // Read completed_from parameter
  const completedFrom = urlParams.get('completed_from');
  if (completedFrom) {
    filters.completed_from = completedFrom;
    hasFilters = true;
  }

  // Read completed_to parameter
  const completedTo = urlParams.get('completed_to');
  if (completedTo) {
    filters.completed_to = completedTo;
    hasFilters = true;
  }

  if (hasFilters) {
    return {
      filters,
      isFilterApplied: true,
      statusFilter: filters.status || [],
      roundFilter: filters.round_no || "",
      ai_scoreFilter: filters.ai_score || "",
      experienceFilter: filters.experience || "",
      evaluationCriteriaFilter: filters.individual_score_filter || {},
      fromDateFilter: filters.created_at_from || "",
      toDateFilter: filters.created_at_to || "",
      completedFromDateFilter: filters.completed_from || "",
      completedToDateFilter: filters.completed_to || "",
    };
  }

  return null;
};

const Applicant = ({ candidates: initialCandidates, onCandidateClose }) => {
  // First check for URL parameters, then fall back to localStorage
  const urlFilters = readUrlParameters();
  const savedState = urlFilters || loadFilterState();
  
  console.log("Applicant component initialized with:", {
    urlFilters,
    savedState,
    isFilterApplied: savedState.isFilterApplied,
    filters: savedState.filters
  });
  
  const [openCloseConfirmation, setOpenCloseConfirmation] = useState(false);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedCandidate, setSelectedCandidate] = useState(null); // Track the candidate to be closed
  const navigate = useNavigate();
  const [localCandidates, setLocalCandidates] = useState(
    initialCandidates || []
  );
  const [dynamicData, setDynamicData] = useState({
    round1ScoreColumn: [],
    otherDynamicColumns: []
  });
  const [totalCount, setTotalCount] = useState(0);
  const [job_opening_id, setJob_opening_id] = useState();
  const [showScoreDescription, setShowScoreDescription] = useState(false);
  const [selectedScoreInfo, setSelectedScoreInfo] = useState(null);
  const [showEditApplicant, setShowEditApplicant] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editedApplicant, setEditedApplicant] = useState(null);
  const [showRemarkModal, setShowRemarkModal] = useState(false);
  const [remarkData, setRemarkData] = useState({
    comment: "",
    type: "CALL",
  });

  // Search state
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearching, setIsSearching] = useState(false);

  // Filter state
  const [openFilterPopover, setOpenFilterPopover] = useState(false);
  const [statusFilter, setStatusFilter] = useState(savedState.statusFilter || []);
  const [roundFilter, setRoundFilter] = useState(savedState.roundFilter);
  const [ai_scoreFilter, setAi_scoreFilter] = useState(savedState.ai_scoreFilter);
  const [experienceFilter, setExperienceFilter] = useState(savedState.experienceFilter);
  const [isFilterApplied, setIsFilterApplied] = useState(
    savedState.isFilterApplied
  );
  const [filters, setFilters] = useState(savedState.filters);
  const [fromDateFilter, setFromDateFilter] = useState(savedState.fromDateFilter || "");
  const [toDateFilter, setToDateFilter] = useState(savedState.toDateFilter || "");

  // New state for evaluation criteria filter
  const [evaluationCriteria, setEvaluationCriteria] = useState([]);
  const [evaluationCriteriaFilter, setEvaluationCriteriaFilter] = useState(
    savedState.evaluationCriteriaFilter || {}
  );

  // Add state for completed date range filter
  const [completedFromDateFilter, setCompletedFromDateFilter] = useState("");
  const [completedToDateFilter, setCompletedToDateFilter] = useState("");

  // Function to convert criteria names to API format
  const formatCriteriaKey = (criteriaName) => {
    return criteriaName.toLowerCase().replace(/\s+/g, '_');
  };

  // Get job_opening_id from URL on mount
  useEffect(() => {
    const urlSegments = window.location.href.split("/");
    const id = urlSegments[4];
    if (id) {
      setJob_opening_id(id);
    }
  }, []);

  // Fetch job opening details to get evaluation criteria
  useEffect(() => {
    const fetchJobOpeningDetails = async () => {
      if (job_opening_id) {
        try {
          const response = await apiCall("get", `${apiEndpoints.JOB_OPENING}/${job_opening_id}`);
          setJobOpeningDetails(response);
          if (response && response.evaluation_criteria) {
            const criteriaKeys = Object.keys(response.evaluation_criteria);
            setEvaluationCriteria(criteriaKeys);
          }
        } catch (error) {
          console.error("Error fetching job opening details:", error);
        }
      }
    };

    fetchJobOpeningDetails();
  }, [job_opening_id]);

  // Save URL filters to localStorage if they exist
  useEffect(() => {
    if (urlFilters) {
      saveFilterState(urlFilters.filters, urlFilters.isFilterApplied);
      // Clear URL parameters after reading them to avoid conflicts
      const url = new URL(window.location);
      url.search = '';
      window.history.replaceState({}, '', url);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Debounce function for search
  const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);

      return () => {
        clearTimeout(handler);
      };
    }, [value, delay]);

    return debouncedValue;
  };

  const debouncedSearchQuery = useDebounce(searchQuery, 300);

  // Update fetch function to use apiCall
  const fetchPaginatedCandidates = useCallback(async () => {
    if (!job_opening_id) return; // Guard clause

    try {
      console.log("fetchPaginatedCandidates called with:", {
        page,
        rowsPerPage,
        isFilterApplied,
        filters,
        debouncedSearchQuery
      });

      // Construct URL with query parameters
      let url = `${apiEndpoints.JOB_OPENING_APPLICANTS}/${job_opening_id}?page=${page}&page_size=${rowsPerPage}`; // Update the endpoint

      // Use search endpoint if search query exists
      if (debouncedSearchQuery.trim()) {
        url = `/api/applicants/search?query=${encodeURIComponent(
          debouncedSearchQuery.trim()
        )}&job_opening_id=${job_opening_id}&page=${page}&page_size=${rowsPerPage}`;
        setIsSearching(true);
        console.log("Using search endpoint:", url);
      } else {
        setIsSearching(false);

        // Add filter parameters if filters are applied
        if (isFilterApplied) {
          const queryParams = new URLSearchParams();

          // Handle multiple status parameters
          if (filters.status && filters.status.length > 0) {
            filters.status.forEach(status => {
              queryParams.append("status", status);
            });
            console.log("Added status filters:", filters.status);
          }
          if (filters.round_no) {
            queryParams.append("round_no", filters.round_no);
            console.log("Added round filter:", filters.round_no);
          }
          if (filters.ai_score)
            queryParams.append("ai_score", filters.ai_score);
          if (filters.experience)
            queryParams.append("experience", filters.experience);

          // Add date filter parameters
          if (filters.created_at_from) {
            queryParams.append("created_at_from", filters.created_at_from);
            console.log("Added created_at_from filter:", filters.created_at_from);
          }
          if (filters.created_at_to) {
            queryParams.append("created_at_to", filters.created_at_to);
            console.log("Added created_at_to filter:", filters.created_at_to);
          }

          // Add individual_score_filter parameter
          if (filters.individual_score_filter && Object.keys(filters.individual_score_filter).length > 0) {
            queryParams.append("individual_score_filter", JSON.stringify(filters.individual_score_filter));
            console.log("Added evaluation criteria filter:", filters.individual_score_filter);
          }

          // Add completed date range parameters
          if (filters.completed_from) {
            queryParams.append("completed_from", filters.completed_from);
            console.log("Added completed_from filter:", filters.completed_from);
          }
          if (filters.completed_to) {
            queryParams.append("completed_to", filters.completed_to);
            console.log("Added completed_to filter:", filters.completed_to);
          }

          queryParams.append("page", page.toString());
          queryParams.append("page_size", rowsPerPage.toString());

          if (queryParams.toString()) {
            url = `${
              apiEndpoints.JOB_OPENING_APPLICANTS
            }/${job_opening_id}?${queryParams.toString()}`;
          }
          console.log("Applied filters, final URL:", url);
        } else {
          console.log("No filters applied, using base URL:", url);
        }
      }

      const response = await apiCall("get", url);

      console.log("API Response received:", {
        itemsCount: response?.items?.length || 0,
        total: response?.total || 0,
        hasItems: !!response?.items
      });
      if (response && response.items) {
        setLocalCandidates(response.items);
        
        const round1ScoreColumn = [];
        const otherDynamicColumns = [];
        
        if (response?.dynamic_headers) {
          response.dynamic_headers.forEach((headerName) => {
            const column = {
              title: (
                <span
                  style={{
                    color: "#27272A",
                    padding: "8px",
                    fontSize: 11,
                    fontWeight: "500",
                  }}
                >
                  {headerName.replace(/_/g, " ")}
                </span>
              ),
              dataIndex: headerName,
              key: headerName,
              render: (_, record) => (
                <span>{record?.dynamic_data?.[headerName] || "N/A"}</span>
              ),
            };
            
            if (headerName === "Round_1_Score") {
              round1ScoreColumn.push(column);
            } else {
              otherDynamicColumns.push(column);
            }
          });
        }
        
        setDynamicData({
          round1ScoreColumn,
          otherDynamicColumns,
        });
        
        setTotalCount(response.total || 0);
        setRowsPerPage(response.page_size || 10);
      }
      else {
        console.warn("Unexpected response format:", response);
        setLocalCandidates([]);
        setDynamicData({
          round1ScoreColumn: [],
          otherDynamicColumns: []
        });
        setTotalCount(0);
      }
    } catch (error) {
      console.error("Error fetching candidates:", error);
      setLocalCandidates([]);
      setTotalCount(0);
    }
  }, [
    page,
    rowsPerPage,
    job_opening_id,
    isFilterApplied,
    filters,
    debouncedSearchQuery,
  ]);

  // Update useEffect to depend on filter changes and search query changes
  useEffect(() => {
    if (job_opening_id) {
      console.log("Fetching data for page:", page);
      fetchPaginatedCandidates();
    }
  }, [
    job_opening_id,
    page,
    fetchPaginatedCandidates,
    isFilterApplied,
    filters,
    debouncedSearchQuery,
  ]);

  console.log("Applicant component initialized with:>>>",initialCandidates);

  // Handle search input change
  const handleSearchInputChange = (e) => {
    setSearchQuery(e.target.value);
    setPage(1); // Reset to first page on new search
  };

  // Clear search
  const handleClearSearch = () => {
    setSearchQuery("");
    setIsSearching(false);
    setPage(1);
  };

  // Filter functions
  const handleFilterClick = () => {
    setOpenFilterPopover(true);
  };

  const handleFilterApply = () => {
    const newFilters = {
      status: statusFilter.length > 0 ? statusFilter : null,
      round_no: roundFilter || null,
      ai_score: ai_scoreFilter || null,
      experience: experienceFilter || null,
      individual_score_filter: Object.keys(evaluationCriteriaFilter).length > 0 ? evaluationCriteriaFilter : null,
      created_at_from: fromDateFilter || null,
      created_at_to: toDateFilter || null,
      completed_from: completedFromDateFilter || null,
      completed_to: completedToDateFilter || null,
    };

    console.log("Applying filters:", newFilters);

    const hasActiveFilters = Object.values(newFilters).some(
      (value) => value !== null && value !== "" && (Array.isArray(value) ? value.length > 0 : true)
    );

    setIsFilterApplied(hasActiveFilters);
    setFilters(newFilters);
    saveFilterState(newFilters, hasActiveFilters);
    setPage(1);
    setOpenFilterPopover(false);
  };

  const handleClearFilters = () => {
    setStatusFilter([]);
    setRoundFilter("");
    setAi_scoreFilter("");
    setExperienceFilter("");
    setEvaluationCriteriaFilter({});
    setFromDateFilter("");
    setToDateFilter("");
    setCompletedFromDateFilter("");
    setCompletedToDateFilter("");
    setIsFilterApplied(false);
    setFilters({});
    saveFilterState({}, false);
    setPage(1);
    setOpenFilterPopover(false);
  };

  // Filter content component
  const filterContent = () => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        maxHeight: "85vh", // Add max height to prevent overflow
        backgroundColor: "#FFFFFF",
        width: "390px",
      }}
    >
      {/* Header */}
      <div
        style={{
          padding: "16px 24px",
          borderBottom: "1px solid #E5E7EB",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#F9FAFB",
          flexShrink: 0, // Prevent header from shrinking
        }}
      >
        <Typography
          variant="subtitle1"
          style={{ fontWeight: 600, color: "#111827" }}
        >
          Filter Applicants
        </Typography>
        <IconButton
          aria-label="close"
          onClick={() => setOpenFilterPopover(false)}
          size="small"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>

      {/* Filter options */}
      <div
        style={{
          padding: "24px 12px 24px 24px",
          flex: 1,
          overflowY: "auto",
          overflowX: "hidden",
          minHeight: 0, // Allow the div to shrink below its content size
        }}
      >
        <div style={{ marginBottom: "24px" }}>
          <div style={labelStyle}>Round</div>
          <Select
            placeholder="Select Round"
            value={roundFilter}
            onChange={setRoundFilter}
            style={{ ...inputStyle, width: "90%" }}
            allowClear
            dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
          >
            <Select.Option value="" disabled>
              <span style={{ color: "#A9A9A9", fontSize: "14px" }}>
                choose from this list
              </span>
            </Select.Option>
            <Select.Option value="1">Round 1</Select.Option>
            <Select.Option value="2">Round 2</Select.Option>
            <Select.Option value="3">Round 3</Select.Option>
            <Select.Option value="4">Round 4</Select.Option>
            <Select.Option value="5">Round 5</Select.Option>
          </Select>
        </div>

        <div style={{ marginBottom: "24px" }}>
          <div style={labelStyle}>Status</div>
          <Select
            mode="multiple"
            placeholder="Select Status"
            value={statusFilter}
            onChange={setStatusFilter}
            style={{ ...inputStyle, width: "90%" }}
            allowClear
            dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
          >
            <Select.Option value="NOT_SCHEDULED">NOT SCHEDULED</Select.Option>
            <Select.Option value="SCHEDULED">SCHEDULED</Select.Option>
            <Select.Option value="VERIFIED">VERIFIED</Select.Option>
            <Select.Option value="REJECTED">REJECTED</Select.Option>
            <Select.Option value="FAILED">FAILED</Select.Option>
            <Select.Option value="STARTED">STARTED</Select.Option>
            <Select.Option value="COMPLETED">COMPLETED</Select.Option>
            <Select.Option value="CANCELED">CANCELED</Select.Option>
            <Select.Option value="CHEATED">CHEATED</Select.Option>
            <Select.Option value="FORWARDED_TO_CLIENT">FORWARDED TO CLIENT</Select.Option>
            <Select.Option value="CLIENT_SHORTLISTED">CLIENT SHORTLISTED</Select.Option>
            <Select.Option value="CLIENT_REJECTED">CLIENT REJECTED</Select.Option>
            <Select.Option value="OFFERED">OFFERED</Select.Option>
            <Select.Option value="OFFER_ACCEPTED">OFFER ACCEPTED</Select.Option>
            <Select.Option value="OFFER_REJECTED">OFFER REJECTED</Select.Option>
            <Select.Option value="JOINED">JOINED</Select.Option>
            <Select.Option value="NO_SHOW">NO SHOW</Select.Option>
            <Select.Option value="TECH_ISSUE">TECH ISSUE</Select.Option>
            <Select.Option value="PASSED">PASSED</Select.Option>
            <Select.Option value="TEST_INTERVIEW">TEST INTERVIEW</Select.Option>
            <Select.Option value="NOT_INTERESTED">NOT INTERESTED</Select.Option>
            <Select.Option value="COMPANY_REJECTED">COMPANY REJECTED</Select.Option>
          </Select>
        </div>

        <div style={{ marginBottom: "24px" }}>
          <div style={labelStyle}>AI Score</div>
          <AntInput
            placeholder="Enter AI Score"
            value={ai_scoreFilter}
            onChange={(e) => setAi_scoreFilter(e.target.value)}
            style={{ ...inputStyle, width: "90%" }}
            allowClear
          />
        </div>
        <div style={{ marginBottom: "24px" }}>
          <div style={labelStyle}>Experience</div>
          <AntInput
            placeholder="Enter Experience"
            value={experienceFilter}
            onChange={(e) => setExperienceFilter(e.target.value)}
            style={{ ...inputStyle, width: "90%" }}
            allowClear
          />
        </div>

        {/* Date Filter Section */}
        <div style={{ marginBottom: "24px" }}>
          <div style={labelStyle}>Creation Date Range</div>
          <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "12px" }}>
            Filter applicants by their application date
          </div>
          
          <div style={{ marginBottom: "12px" }}>
            <div style={{ 
              fontSize: "13px", 
              color: "#374151", 
              marginBottom: "6px",
              fontWeight: "400"
            }}>
              From Date
            </div>
            <AntInput
              type="date"
              placeholder="Select from date"
              value={fromDateFilter}
              onChange={(e) => setFromDateFilter(e.target.value)}
              style={{ ...inputStyle, width: "90%" }}
              allowClear
            />
          </div>
          
          <div style={{ marginBottom: "12px" }}>
            <div style={{ 
              fontSize: "13px", 
              color: "#374151", 
              marginBottom: "6px",
              fontWeight: "400"
            }}>
              To Date
            </div>
            <AntInput
              type="date"
              placeholder="Select to date"
              value={toDateFilter}
              onChange={(e) => setToDateFilter(e.target.value)}
              style={{ ...inputStyle, width: "90%" }}
              allowClear
            />
          </div>
        </div>

        {/* Completed Date Range Filter Section */}
        <div style={{ marginBottom: "24px" }}>
          <div style={labelStyle}>Completed Date Range</div>
          <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "12px" }}>
            Filter applicants by the date they were marked as completed
          </div>
          <div style={{ marginBottom: "12px" }}>
            <div style={{
              fontSize: "13px",
              color: "#374151",
              marginBottom: "6px",
              fontWeight: "400"
            }}>
              Completed From Date
            </div>
            <AntInput
              type="date"
              placeholder="Select completed from date"
              value={completedFromDateFilter}
              onChange={(e) => setCompletedFromDateFilter(e.target.value)}
              style={{ ...inputStyle, width: "90%" }}
              allowClear
            />
          </div>
          <div style={{ marginBottom: "12px" }}>
            <div style={{
              fontSize: "13px",
              color: "#374151",
              marginBottom: "6px",
              fontWeight: "400"
            }}>
              Completed To Date
            </div>
            <AntInput
              type="date"
              placeholder="Select completed to date"
              value={completedToDateFilter}
              onChange={(e) => setCompletedToDateFilter(e.target.value)}
              style={{ ...inputStyle, width: "90%" }}
              allowClear
            />
          </div>
        </div>

        {/* Evaluation Criteria Filter */}
        {evaluationCriteria.length > 0 && (
          <div style={{ marginBottom: "24px" }}>
            <div style={labelStyle}>Evaluation Criteria Scores</div>
            <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "12px" }}>
              Filter applicants by their individual scores (1-10 scale)
            </div>
            {evaluationCriteria.map((criteria, index) => (
              <div key={criteria} style={{ marginBottom: "16px" }}>
                <div style={{ 
                  fontSize: "13px", 
                  color: "#374151", 
                  marginBottom: "6px",
                  fontWeight: "400"
                }}>
                  {criteria.replace(/_/g, ' ')}
                </div>
                <AntInput
                  placeholder="Enter score (1-10)"
                  type="number"
                  min="1"
                  max="10"
                  value={evaluationCriteriaFilter[formatCriteriaKey(criteria)] || ""}
                  onChange={(e) => {
                    const score = e.target.value;
                    const criteriaKey = formatCriteriaKey(criteria);
                    setEvaluationCriteriaFilter(prev => {
                      if (score === "" || score === null || score === undefined) {
                        const { [criteriaKey]: removed, ...rest } = prev;
                        return rest;
                      }
                      return {
                        ...prev,
                        [criteriaKey]: parseFloat(score)
                      };
                    });
                  }}
                  style={{ ...inputStyle, width: "90%", fontSize: "13px" }}
                  allowClear
                />
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Action buttons - Fixed at bottom */}
      <div
        style={{
          padding: "16px 24px",
          borderTop: "1px solid #E5E7EB",
          display: "flex",
          justifyContent: "flex-end",
          gap: "14px",
          backgroundColor: "#F9FAFB",
          height: "80px",
          flexShrink: 0, // Prevent buttons from shrinking
        }}
      >
        <div
          onClick={handleClearFilters}
          style={{
            cursor: "pointer",
            marginRight: "-10px",
            marginTop: "12px",
          }}
        >
          <img src={CancelSvg} alt="Clear" width="180px" height="70px" />
        </div>
        <div
          onClick={handleFilterApply}
          style={{
            cursor: "pointer",
            marginRight: "0px",
            marginTop: "10px",
          }}
        >
          <img src={SaveSvg} alt="Apply" width="180px" height="70px"/>
        </div>
      </div>
    </div>
  );

  const handleCloseClick = (candidate) => {
    setSelectedCandidate(candidate);
    setOpenCloseConfirmation(true);
  };

  const handleCloseConfirmation = useCallback(
    (confirmed) => {
      setOpenCloseConfirmation(false);
      if (confirmed && selectedCandidate) {
        // Remove the candidate from the local state
        setLocalCandidates((prevCandidates) =>
          prevCandidates.filter((c) => c.id !== selectedCandidate.id)
        );

        // Call the parent component's onCandidateClose function
        if (onCandidateClose) {
          onCandidateClose(selectedCandidate.id);
        }

        console.log(
          `Application for ${selectedCandidate.candidate_name} closed.`
        );
      }
      setSelectedCandidate(null);
    },
    [selectedCandidate, onCandidateClose]
  );

  const handlePageChange = (event, newPage) => {
    console.log("Changing to page:", newPage);
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const navigateToCandidate = (id) => {
    navigate(`/candidate-details?applicant_id=${id}`);
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      // You can add a notification here if you want to inform the user that the ID was copied
      console.log("ID copied to clipboard");
    });
  };

  const handleShowScoreDescription = (record) => {
    setSelectedScoreInfo({
      summary: record.ai_summary,
      candidateName: record.candidate_name,
      individualScores: record.individual_scores,
    });
    setShowScoreDescription(true);
  };

  const handleEditApplicant = (candidate) => {
    setSelectedCandidate({ ...candidate });
    setEditedApplicant({ ...candidate });
    setShowEditApplicant(true);
    setIsEditing(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedApplicant((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAlphabeticInput = (e) => {
    // Allow only alphabetic characters, spaces, and basic punctuation
    const pattern = /^[a-zA-Z\s.,'-]*$/;
    if (!pattern.test(e.target.value)) {
      e.preventDefault();
      return;
    }
    handleInputChange(e);
  };

  const handleNumericInput = (e, fieldName) => {
    // Allow only numeric input for specific fields
    const value = e.target.value.replace(/[^0-9]/g, "");
    setEditedApplicant((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  const handleSaveApplicantDetails = async () => {
    try {
      if (!editedApplicant) return;

      const response = await apiCall("put", `/api/applicants`, editedApplicant);

      if (response) {
        // Update local state with edited applicant
        setLocalCandidates((prev) =>
          prev.map((candidate) =>
            candidate.id === editedApplicant.id ? editedApplicant : candidate
          )
        );

        // Close the modal
        setShowEditApplicant(false);
        setIsEditing(false);
        message.success("Applicant details updated successfully");
      }
    } catch (error) {
      console.error("Error updating applicant details:", error);
      message.error("Failed to update applicant details");
    }
  };

  const handleAddRemark = (candidate) => {
    setSelectedCandidate({ ...candidate });
    setShowRemarkModal(true);
    setRemarkData({
      comment: "",
      type: "CALL",
    });
  };

  const handleRemarkInputChange = (e) => {
    const { name, value } = e.target;
    setRemarkData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleRemarkTypeChange = (value) => {
    setRemarkData((prev) => ({
      ...prev,
      type: value,
    }));
  };

  const handleSubmitRemark = async () => {
    try {
      if (!selectedCandidate || !remarkData.comment) {
        message.error("Please add a comment");
        return;
      }

      const payload = {
        id: selectedCandidate.id,
        remark: {
          comment: remarkData.comment,
          type: remarkData.type,
        },
      };

      const response = await apiCall("put", `/api/applicants`, payload);

      if (response) {
        setShowRemarkModal(false);
        message.success("Remark added successfully");
        // Refresh the candidate list
        fetchPaginatedCandidates();
      }
    } catch (error) {
      console.error("Error adding remark:", error);
      message.error("Failed to add remark");
    }
  };

  // Style definitions
  const inputStyle = {
    width: "368px",
    height: "34px",
    padding: "6px 10px",
    gap: "8px",
    borderRadius: "6px",
    border: "1px solid rgba(255, 255, 255, 1)",
    boxShadow:
      "0px 1px 2px 0px rgba(17, 24, 39, 0.08), 0px 0px 0px 1px rgba(17, 24, 39, 0.1)",
    backgroundColor: "#F3F4F6",
    fontSize: "14px",
    fontFamily: "Inter",
  };

  const labelStyle = {
    display: "block",
    fontSize: "14px",
    color: "#374151",
    marginBottom: "8px",
    fontWeight: "500",
  };

  const action = {
    title: (
      <span
        style={{
          color: "#27272A",
          padding: "8px",
          fontSize: 11,
          fontWeight: "500",
        }}
      >
        Actions
      </span>
    ),
    key: "actions",
    render: (_, record) => (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item
              key="edit"
              icon={<EditOutlined />}
              onClick={(e) => {
                e.domEvent.stopPropagation();
                handleEditApplicant(record);
              }}
            >
              Edit Applicant
            </Menu.Item>
            <Menu.Item
              key="remark"
              icon={<MessageOutlined />}
              onClick={(e) => {
                e.domEvent.stopPropagation();
                handleAddRemark(record);
              }}
            >
              Add Remark
            </Menu.Item>
            <Menu.Item
              key="whatsapp-history"
              icon={<InfoCircleOutlined />}
              onClick={(e) => {
                e.domEvent.stopPropagation();
                handleViewWhatsappHistory(record);
              }}
            >
              WhatsApp History
            </Menu.Item>
            <Menu.Item
              key="whatsapp-send"
              icon={<WhatsAppOutlined />}
              onClick={(e) => {
                e.domEvent.stopPropagation();
                handleRowSendWhatsapp(record);
              }}
            >
              Send WhatsApp
            </Menu.Item>
            <Menu.Item
              key="delete"
              icon={<CloseOutlined />}
              onClick={(e) => {
                e.domEvent.stopPropagation();
                handleCloseClick(record);
              }}
              danger
            >
              Delete
            </Menu.Item>
          </Menu>
        }
        trigger={["click"]}
      >
        <AntButton
          type="text"
          icon={<MoreOutlined />}
          onClick={(e) => e.stopPropagation()}
          size="small"
        />
      </Dropdown>
    ),
  };

  const [selectionMode, setSelectionMode] = useState("manual");
  const [selectedApplicants, setSelectedApplicants] = useState([]);
  const [selectionMenuAnchor, setSelectionMenuAnchor] = useState(null);
  const [emailConfirmOpen, setEmailConfirmOpen] = useState(false);
  const [isSendingEmail, setIsSendingEmail] = useState(false);
  const [whatsappConfirmOpen, setWhatsappConfirmOpen] = useState(false);
  const [isSendingWhatsApp, setIsSendingWhatsApp] = useState(false);
  const [customModalVisible, setCustomModalVisible] = useState(false);
  const [historyDialogVisible, setHistoryDialogVisible] = useState(false);
  const [whatsappHistory, setWhatsappHistory] = useState([]);
  const [currentCandidateForWhatsApp, setCurrentCandidateForWhatsApp] = useState(null);
  const [customMessage, setCustomMessage] = useState("");
  const [jobOpeningDetails, setJobOpeningDetails] = useState(null);

  const handleSendEmails = async () => {
    if (selectedApplicants.length === 0) {
      toasty("Please select at least one applicant", "warning");
      return;
    }
    setIsSendingEmail(true);
    try {
      const response = await apiCall(
        "post",
        apiEndpoints.SEND_INTERVIEW_EMAILS,
        {
          applicant_ids: selectedApplicants,
          jobopening_id: job_opening_id,
        }
      );

      if (response) {
        toasty("Emails sent successfully", "success");
        // Reset selections after successful send
        setSelectionMode("none");
        setSelectedApplicants([]);
      } else {
        toasty("Failed to send emails", "error");
      }
    } catch (error) {
      console.error("Error sending emails:", error);
      toasty("Error sending emails", "error");
    } finally {
      setIsSendingEmail(false);
    }
  };

  const handleSendWhatsApp = async () => {
    if (selectedApplicants.length === 0) {
      toasty("Please select at least one applicant", "warning");
      return;
    }
    setIsSendingWhatsApp(true);
    try {
      for (let id of selectedApplicants) {
        const record = localCandidates.find((c) => c.id === id);
        const payload = {...record, jobOpeningDetails: jobOpeningDetails}
        await apiCall(
          "post",
          "https://n8n.prompthire.ai/webhook/send-panel-wa-message",
          payload,
          {

          }
        );
      }
      toasty("WhatsApp messages sent successfully", "success");
      // setSelectionMode("none");
      // setSelectedApplicants([]);
    } catch (error) {
      console.error("Error sending WhatsApp messages:", error);
      toasty("Error sending WhatsApp messages", "error");
    } finally {
      setIsSendingWhatsApp(false);
    }
  };


  const handleWhatsAppButtonClick = () => {
    setWhatsappConfirmOpen(true);
  };

  const handleWhatsAppConfirmClose = () => {
    setWhatsappConfirmOpen(false);
  };

  const handleWhatsAppConfirm = () => {
    handleSendWhatsApp();
    setWhatsappConfirmOpen(false);
  };

  const handleRowSendWhatsapp = (record) => {
    setCurrentCandidateForWhatsApp(record);
    setCustomMessage("");
    setCustomModalVisible(true);
  };

  const handleSendCustomMessage = async () => {
    if (!customMessage.trim()) {
      toasty("Please enter a message", "warning");
      return;
    }
    setIsSendingWhatsApp(true);
    try {
      const payload = new URLSearchParams({
        channel: "whatsapp",
        source: "918279594694",
        destination: currentCandidateForWhatsApp?.candidate_phone,
        "src.name": "PrompthireAI",
        message: JSON.stringify({ text: customMessage }),
      });
      await apiCall(
        "post",
        "https://api.gupshup.io/wa/api/v1/template/msg",
        payload.toString(),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            apikey: "yyscvawswqrxcc06lcy2esdewsundyvo",
          },
        }
      );
      toasty("Message sent", "success");
      setCustomModalVisible(false);
      setCurrentCandidateForWhatsApp(null);
    } catch (error) {
      console.error("Error sending custom WhatsApp:", error);
      toasty("Error sending message", "error");
    } finally {
      setIsSendingWhatsApp(false);
    }
  };

  const handleViewWhatsappHistory = async (record) => {
    setCurrentCandidateForWhatsApp(record);
    setHistoryDialogVisible(true);
    try {
      const response = await apiCall(
        "get",
        `${apiEndpoints.GET_WHATSAPP_HISTORY}/${record.id}`
      );
      setWhatsappHistory(response.items || []);
    } catch (error) {
      console.error("Error fetching WhatsApp history:", error);
      toasty("Failed to fetch message history", "error");
    }
  };

  const handleEmailButtonClick = () => {
    setEmailConfirmOpen(true);
  };
  const handleEmailConfirmClose = () => {
    setEmailConfirmOpen(false);
  };
  const handleEmailConfirm = () => {
    handleSendEmails();
    setEmailConfirmOpen(false);
  };
  const handleSelectionMenuClose = () => {
    
    setSelectionMenuAnchor(null);
  };

  const handleSelectionModeChange = async (mode) => {
    setSelectionMode(mode);
    setSelectedApplicants([]);
    handleSelectionMenuClose();
  };

  const handleApplicantSelection = (e, applicantId) => {
    e.stopPropagation();

    setSelectedApplicants((prev) => {
      if (prev.includes(applicantId)) {
        return prev.filter((id) => id !== applicantId);
      } else {
        return [...prev, applicantId];
      }
    });
  };

  
  const columns = [
    selectionMode === "manual"
      ? {
          title: "",
          width: 48,
          render: (_, record) => (
            <Checkbox
              checked={selectedApplicants?.includes(record?.id)}
              onChange={(e) => handleApplicantSelection(e, record?.id)}
              onClick={(e) => e?.stopPropagation()}
            />
          ),
        }
      : {
          title: "",
          width: 4,
        },
    {
      title: (
        <span
          style={{
            color: "#27272A",
            padding: "8px",
            fontSize: 11,
            fontWeight: "500",
          }}
        >
          ID
        </span>
      ),
      dataIndex: "id",
      fixed: "left", 

      render: (text) => (
        <>
          {text.slice(-10)}
          <Tooltip title="Copy ID">
            <Button
              icon={<CopyOutlined />}
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                copyToClipboard(text);
              }}
              style={{ marginLeft: 8 }}
            />
          </Tooltip>
        </>
      ),
    },

    {
      title: (
        <span
          style={{
            color: "#27272A",
            padding: "8px",
            fontSize: 11,
            fontWeight: "500",
          }}
        >
          Date
        </span>
      ),
      dataIndex: "created_at", // Replace with your actual date field if different
      fixed: "left", 
      render: (date) => {
        if (!date) return "N/A";
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
      },
    },
    
    {
      title: (
        <span
          style={{
            color: "#27272A",
            padding: "8px",
            fontSize: 11,
            fontWeight: "500",
          }}
        >
          Candidate Name
        </span>
      ),
      dataIndex: "candidate_name",
      fixed: "left", 
    },
    
    
    // {
    //   title: (
    //     <span
    //       style={{
    //         color: "#27272A",
    //         padding: "8px",
    //         fontSize: 11,
    //         fontWeight: "500",
    //       }}
    //     >
    //       AI Score
    //     </span>
    //   ),
    //   dataIndex: "ai_score",
    //   fixed: "left", 

    //   render: (text) => text || "0.0",
    // },
    {
      title: (
        <span
          style={{
            color: "#27272A",
            padding: "8px",
            fontSize: 11,
            fontWeight: "500",
          }}
        >CV Score
          
        </span>
      ),
      dataIndex: "ai_score",
      fixed:'left',
      key: "individual_score",
      render: (score, record) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <span>{score || "0.0"}</span>
          <AntButton
            type="text"
            icon={<InfoCircleOutlined />}
            onClick={(e) => {
              e.stopPropagation();
              handleShowScoreDescription(record);
            }}
            size="small"
            style={{ marginLeft: 8 }}
          />
        </div>
      ),
    },
    {
      title: (
        <span
          style={{
            color: "#27272A",
            padding: "8px",
            fontSize: 11,
            fontWeight: "500",
          }}
        >
          Notable Companies
        </span>
      ),
      dataIndex: "notable_company",
      render: (companies) => (companies ? companies.join(", ") : "N/A"),
    },
    {
      title: (
        <span
          style={{
            color: "#27272A",
            padding: "8px",
            fontSize: 11,
            fontWeight: "500",
          }}
        >
          Current CTC
        </span>
      ),
      dataIndex: "current_ctc",
      render: (text) => (text ? `₹${text.toLocaleString()}` : "N/A"),
    },
    {
      title: (
        <span
          style={{
            color: "#27272A",
            padding: "8px",
            fontSize: 11,
            fontWeight: "500",
          }}
        >
          Current Company
        </span>
      ),
      dataIndex: "current_company",
    },
    {
      title: (
        <span
          style={{
            color: "#27272A",
            padding: "8px",
            fontSize: 11,
            fontWeight: "500",
          }}
        >
          Expected CTC
        </span>
      ),
      dataIndex: "expected_ctc",
      render: (text) => (text ? `₹${text.toLocaleString()}` : "N/A"),
    },
    {
      title: (
        <span
          style={{
            color: "#27272A",
            padding: "8px",
            fontSize: 11,
            fontWeight: "500",
          }}
        >
          Notice Period
        </span>
      ),
      dataIndex: "notice_period",
    },
   
    {
      title: (
        <span
          style={{
            color: "#27272A",
            padding: "8px",
            fontSize: 11,
            fontWeight: "500",
          }}
        >
          Experience
        </span>
      ),
      dataIndex: "experience",
    },
    {
      title: (
        <span
          style={{
            color: "#27272A",
            padding: "8px",
            fontSize: 11,
            fontWeight: "500",
            whiteSpace: "nowrap",
          }}
        >
          CV Source
        </span>
      ),
      dataIndex: "resume_source",
      render: (text) => (
        <Tooltip title={text || "No Source available"}>
          <span>
            {text ? (text.length > 20 ? `${text.slice(0, 20)}...` : text) : "No Source available"}
          </span>
        </Tooltip>
      ),
    },
    {
      title: (
        <span
          style={{
            color: "#27272A",
            padding: "8px",
            fontSize: 11,
            fontWeight: "500",
          }}
        >
          Current Location
        </span>
      ),
      dataIndex: "current_location",
    },
   
   
    {
      title: (
        <span
          style={{
            color: "#27272A",
            padding: "8px",
            fontSize: 11,
            fontWeight: "500",
          }}
        >
          AI Summary
        </span>
      ),
      dataIndex: "ai_summary",
      render: (text) => (
        <Tooltip title={text || "No summary available"}>
          <span>
            {text ? `${text.slice(0, 20)}...` : "No summary available"}
          </span>
        </Tooltip>
      ),
    },
    {
      title: (
        <span
          style={{
            color: "#27272A",
            padding: "8px",
            fontSize: 11,
            fontWeight: "500",
          }}
        >
          Remarks
        </span>
      ),
      dataIndex: "remarks",
      key: "remarks",
      render: (remarks, record) => {
        if (!remarks || remarks.length === 0) {
          return (
            <span style={{ color: "#9CA3AF", fontSize: "12px" }}>
              No remarks
            </span>
          );
        }

        const sortedRemarks = [...remarks].sort(
          (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
        );

        const content = (
          <div
            style={{ maxWidth: "320px", maxHeight: "300px", overflow: "auto" }}
          >
            {sortedRemarks.map((remark, index) => {
              const date = new Date(remark.timestamp);
              const formattedDate = date.toLocaleString(undefined, {
                year: "2-digit",
                month: "short",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              });

              return (
                <div
                  key={index}
                  style={{
                    padding: "8px 10px",
                    borderBottom:
                      index < sortedRemarks.length - 1
                        ? "1px solid #E5E7EB"
                        : "none",
                    backgroundColor: index % 2 === 0 ? "#F9FAFB" : "#FFFFFF",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "6px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <span
                        style={{
                          fontWeight: "500",
                          fontSize: "11px",
                          backgroundColor:
                            remark.type === "CALL" ? "#E1EFFE" : "#F0FDF4",
                          color: remark.type === "CALL" ? "#1E40AF" : "#166534",
                          padding: "1px 5px",
                          borderRadius: "3px",
                          display: "inline-block",
                        }}
                      >
                        {remark.type}
                      </span>
                      <span style={{ fontSize: "11px", color: "#6B7280" }}>
                        {formattedDate}
                      </span>
                    </div>
                  </div>
                  <div
                    style={{
                      fontSize: "12px",
                      lineHeight: "1.4",
                      color: "#374151",
                      wordBreak: "break-word",
                    }}
                  >
                    {remark.comment}
                  </div>
                </div>
              );
            })}
          </div>
        );

        return (
          <Dropdown
            overlay={content}
            trigger={["click"]}
            placement="bottomRight"
            overlayStyle={{ maxHeight: "400px", overflowY: "auto" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                padding: "4px 8px",
                borderRadius: "4px",
                border: "1px solid #E5E7EB",
                backgroundColor: "#F9FAFB",
                width: "fit-content",
              }}
            >
              <span style={{ fontSize: "12px" }}>
                {remarks.length} remark{remarks.length !== 1 ? "s" : ""}
              </span>
            </div>
          </Dropdown>
        );
      },
    },
    {
      title: (
        <span
          style={{
            color: "#27272A",
            padding: "8px",
            fontSize: 11,
            fontWeight: "500",
          }}
        >
          Email
        </span>
      ),
      dataIndex: "candidate_email",
    },
    {
      title: (
        <span
          style={{
            color: "#27272A",
            padding: "8px",
            fontSize: 11,
            fontWeight: "500",
          }}
        >
          Phone
        </span>
      ),
      dataIndex: "candidate_phone",
    },
  ]


  const renderEditApplicantComponent = () => {
    return (
      <div
        style={{
          width: "410px",
          height: "88vh",
          fontFamily: "inter",
          padding: "0",
          borderRadius: "12px",
          backgroundColor: "#FFFFFF",
          overflowY: "auto",
          overflowX: "hidden",
          boxShadow: `
						0px 20px 44px 0px rgba(0, 0, 0, 0.1),
						0px 80px 80px 0px rgba(0, 0, 0, 0.09),
						0px 180px 108px 0px rgba(0, 0, 0, 0.05)
					`,
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "16px 20px",
            borderBottom: "1px solid #E5E7EB",
            backgroundColor: "#F9FAFB",
          }}
        >
          <Typography
            variant="subtitle1"
            style={{ fontWeight: 600, color: "#111827" }}
          >
            Edit Applicant Details
          </Typography>
          <IconButton
            aria-label="close"
            onClick={() => {
              setShowEditApplicant(false);
              setIsEditing(false);
            }}
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </div>

        {/* Form content */}
        <div style={{ padding: "20px" }}>
          {editedApplicant && (
            <>
              <div style={{ marginBottom: "16px" }}>
                <Typography
                  style={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#374151",
                    marginBottom: "6px",
                  }}
                >
                  Candidate Name
                </Typography>
                <AntInput
                  name="candidate_name"
                  value={editedApplicant.candidate_name || ""}
                  onChange={handleInputChange}
                  placeholder="Enter candidate name"
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    borderRadius: "6px",
                    border: "1px solid #D1D5DB",
                    fontSize: "14px",
                    backgroundColor: "#F9FAFB",
                  }}
                />
              </div>

              <div style={{ marginBottom: "16px" }}>
                <Typography
                  style={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#374151",
                    marginBottom: "6px",
                  }}
                >
                  Email
                </Typography>
                <AntInput
                  name="candidate_email"
                  value={editedApplicant.candidate_email || ""}
                  onChange={handleInputChange}
                  placeholder="Enter email address"
                  type="email"
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    borderRadius: "6px",
                    border: "1px solid #D1D5DB",
                    fontSize: "14px",
                    backgroundColor: "#F9FAFB",
                  }}
                />
              </div>

              <div style={{ marginBottom: "16px" }}>
                <Typography
                  style={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#374151",
                    marginBottom: "6px",
                  }}
                >
                  Phone
                </Typography>
                <AntInput
                  name="candidate_phone"
                  value={editedApplicant.candidate_phone || ""}
                  onChange={(e) => handleNumericInput(e, "candidate_phone")}
                  placeholder="Enter phone number"
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    borderRadius: "6px",
                    border: "1px solid #D1D5DB",
                    fontSize: "14px",
                    backgroundColor: "#F9FAFB",
                  }}
                />
              </div>

              <div style={{ marginBottom: "16px" }}>
                <Typography
                  style={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#374151",
                    marginBottom: "6px",
                  }}
                >
                  Current Location
                </Typography>
                <AntInput
                  name="current_location"
                  value={editedApplicant.current_location || ""}
                  onChange={handleInputChange}
                  placeholder="Enter current location"
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    borderRadius: "6px",
                    border: "1px solid #D1D5DB",
                    fontSize: "14px",
                    backgroundColor: "#F9FAFB",
                  }}
                />
              </div>

              <div style={{ marginBottom: "16px" }}>
                <Typography
                  style={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#374151",
                    marginBottom: "6px",
                  }}
                >
                  Current CTC
                </Typography>
                <AntInput
                  name="current_ctc"
                  value={editedApplicant.current_ctc || ""}
                  onChange={(e) => handleNumericInput(e, "current_ctc")}
                  placeholder="Enter current CTC"
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    borderRadius: "6px",
                    border: "1px solid #D1D5DB",
                    fontSize: "14px",
                    backgroundColor: "#F9FAFB",
                  }}
                />
              </div>

              <div style={{ marginBottom: "16px" }}>
                <Typography
                  style={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#374151",
                    marginBottom: "6px",
                  }}
                >
                  Expected CTC
                </Typography>
                <AntInput
                  name="expected_ctc"
                  value={editedApplicant.expected_ctc || ""}
                  onChange={(e) => handleNumericInput(e, "expected_ctc")}
                  placeholder="Enter expected CTC"
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    borderRadius: "6px",
                    border: "1px solid #D1D5DB",
                    fontSize: "14px",
                    backgroundColor: "#F9FAFB",
                  }}
                />
              </div>

              <div style={{ marginBottom: "16px" }}>
                <Typography
                  style={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#374151",
                    marginBottom: "6px",
                  }}
                >
                  Notice Period (in days)
                </Typography>
                <AntInput
                  name="notice_period"
                  value={editedApplicant.notice_period || ""}
                  onChange={(e) => handleNumericInput(e, "notice_period")}
                  placeholder="Enter notice period"
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    borderRadius: "6px",
                    border: "1px solid #D1D5DB",
                    fontSize: "14px",
                    backgroundColor: "#F9FAFB",
                  }}
                />
              </div>

              <div style={{ marginBottom: "16px" }}>
                <Typography
                  style={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#374151",
                    marginBottom: "6px",
                  }}
                >
                  Current Company
                </Typography>
                <AntInput
                  name="current_company"
                  value={editedApplicant.current_company || ""}
                  onChange={handleInputChange}
                  placeholder="Enter current company"
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    borderRadius: "6px",
                    border: "1px solid #D1D5DB",
                    fontSize: "14px",
                    backgroundColor: "#F9FAFB",
                  }}
                />
              </div>

              <div style={{ marginBottom: "16px" }}>
                <Typography
                  style={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#374151",
                    marginBottom: "6px",
                  }}
                >
                  Experience (in years)
                </Typography>
                <AntInput
                  name="experience"
                  value={editedApplicant.experience || ""}
                  onChange={(e) => handleNumericInput(e, "experience")}
                  placeholder="Enter experience in years"
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    borderRadius: "6px",
                    border: "1px solid #D1D5DB",
                    fontSize: "14px",
                    backgroundColor: "#F9FAFB",
                  }}
                />
              </div>
            </>
          )}
        </div>

        {/* Action buttons */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "16px 20px",
            borderTop: "1px solid #E5E7EB",
            backgroundColor: "#F9FAFB",
            position: "sticky",
            bottom: 0,
          }}
        >
          <div
            onClick={() => {
              setShowEditApplicant(false);
              setIsEditing(false);
            }}
            style={{
              cursor: "pointer",
              marginRight: "20px",
            }}
          >
            <img src={CancelSvg} alt="Cancel" width="180px" height="70px" />
          </div>
          <div
            onClick={handleSaveApplicantDetails}
            style={{
              cursor: "pointer",
            }}
          >
            <img src={SaveSvg} alt="Save" width="180px" height="70px" />
          </div>
        </div>
      </div>
    );
  };

  const renderRemarkComponent = () => {
    return (
      <div
        style={{
          width: "410px",
          padding: "24px",
          borderRadius: "12px",
          backgroundColor: "#FFFFFF",
          boxShadow: `
						0px 20px 44px 0px rgba(0, 0, 0, 0.1),
						0px 80px 80px 0px rgba(0, 0, 0, 0.09),
						0px 180px 108px 0px rgba(0, 0, 0, 0.05)
					`,
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
            Add Remark
          </Typography>
          <IconButton
            aria-label="close"
            onClick={() => setShowRemarkModal(false)}
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </div>

        {/* Form content */}
        <div>
          <div style={{ marginBottom: "16px" }}>
            <Typography
              style={{
                fontSize: "14px",
                fontWeight: 500,
                color: "#374151",
                marginBottom: "6px",
              }}
            >
              Remark Type
            </Typography>
            <Dropdown
              overlay={
                <Menu onClick={(e) => handleRemarkTypeChange(e.key)}>
                  <Menu.Item key="CALL">CALL</Menu.Item>
                  <Menu.Item key="WHATSAPP">WHATSAPP</Menu.Item>
                </Menu>
              }
              trigger={["click"]}
            >
              <AntButton
                style={{
                  width: "100%",
                  textAlign: "left",
                  height: "40px",
                  borderRadius: "6px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {remarkData.type} <MoreOutlined />
              </AntButton>
            </Dropdown>
          </div>

          <div style={{ marginBottom: "16px" }}>
            <Typography
              style={{
                fontSize: "14px",
                fontWeight: 500,
                color: "#374151",
                marginBottom: "6px",
              }}
            >
              Comment
            </Typography>
            <textarea
              name="comment"
              value={remarkData.comment}
              onChange={handleRemarkInputChange}
              placeholder="Enter your remark here..."
              style={{
                width: "100%",
                padding: "10px 12px",
                borderRadius: "6px",
                border: "1px solid #D1D5DB",
                fontSize: "14px",
                color: "#374151",
                backgroundColor: "#F9FAFB",
                minHeight: "100px",
                resize: "vertical",
              }}
            />
          </div>

          {/* Action buttons */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "24px",
              gap: "12px",
            }}
          >
            <Button
              onClick={() => setShowRemarkModal(false)}
              style={{
                color: "#374151",
                backgroundColor: "#F3F4F6",
                borderRadius: "6px",
                padding: "8px 16px",
                border: "none",
                fontSize: "14px",
                fontWeight: 500,
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleSubmitRemark}
              style={{
                color: "white",
                backgroundColor: "#2563EB",
                borderRadius: "6px",
                padding: "8px 16px",
                border: "none",
                fontSize: "14px",
                fontWeight: 500,
              }}
            >
              Submit
            </Button>
          </div>
        </div>
      </div>
    );
  };

  const FormField = ({
    label,
    name,
    value,
    onChange,
    placeholder,
    type = "text",
  }) => {
    return (
      <div style={{ marginBottom: "16px" }}>
        <Typography
          style={{
            fontSize: "14px",
            fontWeight: 500,
            color: "#374151",
            marginBottom: "6px",
          }}
        >
          {label}
        </Typography>
        <input
          type={type}
          name={name}
          value={value}
          onChange={onChange}sa
          placeholder={placeholder}
          style={{
            width: "100%",
            padding: "10px 12px",
            borderRadius: "6px",
            border: "1px solid #D1D5DB",
            fontSize: "14px",
            color: "#374151",
            backgroundColor: "#F9FAFB",
          }}
        />
      </div>
    );
  };

  return (
    <div style={{ padding: "0 24px", fontFamily: "Inter", fontWeight: 400 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "16px",
          alignItems: "center",
        }}
      >
        {selectionMode !== "none" && selectedApplicants.length > 0 && (
          <>
            <Button
              type="primary"
              icon={<MailOutlined />}
              onClick={handleEmailButtonClick}
              disabled={isSendingEmail}
              style={{ background: "#3D72E4", color: "#fff" }}
            >
              {isSendingEmail
                ? "Sending..."
                : `Send Email${selectedApplicants.length > 1 ? "s" : ""} (${selectedApplicants.length})`}
            </Button>
            <Button
              type="primary"
              icon={<WhatsAppOutlined />}
              onClick={handleWhatsAppButtonClick}
              disabled={isSendingWhatsApp}
              style={{ background: "#25D366", color: "#fff", marginLeft: 8 }}
            >
              {isSendingWhatsApp
                ? "Sending..."
                : `Send WhatsApp${selectedApplicants.length > 1 ? "s" : ""} (${selectedApplicants.length})`}
            </Button>
          </>
        )}

        {/* Search Input moved to the right */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "300px",
            marginLeft: "auto", // This will push the search bar to the right
            marginRight: "20px",
          }}
        >
          <AntInput
            placeholder="Search by name, email, phone..."
            value={searchQuery}
            onChange={handleSearchInputChange}
            style={{
              borderRadius: "6px",
              height: "38px",
            }}
            prefix={<SearchOutlined style={{ color: "#9CA3AF" }} />}
            suffix={
              searchQuery ? (
                <CloseOutlined
                  style={{ color: "#9CA3AF", cursor: "pointer" }}
                  onClick={handleClearSearch}
                />
              ) : null
            }
          />
        </div>

        {/* Filter Button */}
        <div
          onClick={handleFilterClick}
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            marginRight: 20,
          }}
        >
          <img
            src={isFilterApplied ? FilterAppliedSvg : FilterSvg}
            alt={isFilterApplied ? "Filters Applied" : "Filter"}
            width="80px"
            height="40px"
          />
        </div>
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item onClick={() => handleSelectionModeChange("manual")}>
                <Radio checked={selectionMode === "manual"}>
                  Choose Recipients
                </Radio>
              </Menu.Item>
              <Menu.Item onClick={() => handleSelectionModeChange("none")}>
                <Radio checked={selectionMode === "none"}>
                  Clear Recipients
                </Radio>
              </Menu.Item>
            </Menu>
          }
          trigger={["click"]}
        >
          <img
            src={YourSVG}
            alt="Select Recipients"
            style={{ cursor: "pointer", height: "32px", width: "155px" }}
          />
        </Dropdown>
      </div>
      <div
        style={{
          width: "100%",
          borderRadius: "8px",
          border: "0.5px solid rgba(218, 218, 221, 1)",
          overflow: "hidden", // Add this to contain the table and pagination
          position: "relative", // Change from absolute positioning
        }}
      >
        <AntTable
          columns={[
            ...columns.slice(0, 4),                      // ID, Date, Candidate Name, AI Score
            {
              title: (
                <span style={{
                  color: "#27272A",
                  padding: "8px",
                  fontSize: 11,
                  fontWeight: "500",
                }}>
                  Is Interested
                </span>
              ),
              dataIndex: "is_interested",
              render: (val, record) => (!record.WaReply ? "Not Captured" : (val ? "Yes" : "No")),
            },
            {
              title: (
                <span style={{
                  color: "#27272A",
                  padding: "8px",
                  fontSize: 11,
                  fontWeight: "500",
                }}>
                  WA Reply
                </span>
              ),
              dataIndex: "WaReply",
              render: (text) => text || "N/A",
            },
            ...(dynamicData?.round1ScoreColumn || []),   // Round_1_Score with fallback
            ...columns.slice(4),                         // Rest of static columns
            {
              title: (
                <span style={{
                  color: "#27272A",
                  padding: "8px",
                  fontSize: 11,
                  fontWeight: "500",
                }}>
                  WhatsApp Status
                </span>
              ),
              dataIndex: "whatsapp_status_intent",
              render: (status) => status || "N/A",
            },

            ...(dynamicData?.otherDynamicColumns || []), // Other dynamic columns with fallback
          ]}
          dataSource={localCandidates}
          rowKey="id"
          size="small"
          pagination={false}
          scroll={{ x: 4000, y: "70vh" }}
          onRow={(record) => ({
            onClick: () => navigateToCandidate(record.id),
            style: { cursor: "pointer" },
          })}
          style={{
            background: "var(--White, rgba(255, 255, 255, 1))",
            width: "100%",
            height: "65vh",
            borderRadius: "8px 8px 0 0",
          }}
          rowClassName={(_, index) =>
            index % 2 === 0 ? "even-row" : "odd-row"
          }
          onHeaderRow={() => ({
            style: { whiteSpace: "nowrap" },
          })}
        />

        {/* Wrapper with Flexbox for proper alignment */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between", // ✅ Space between Left and Right
            alignItems: "center",
            width: "100%",
          }}
        >
          {/* Showing X of Y Candidates */}
          <div
            style={{
              fontFamily: "Inter, sans-serif",
              fontSize: "12px",
              fontWeight: 500,
              color: "#333",
              marginLeft: "8px",
            }}
          >
            Showing {Math.min(rowsPerPage, localCandidates.length)} of{" "}
            {totalCount} Candidates
          </div>

          {/* Centered Pagination with Flex Wrapper */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flex: 1, // ✅ Ensures pagination stays in center
            }}
          >
            <CustomPagination
              current={page}
              total={totalCount}
              pageSize={rowsPerPage}
              onChange={(newPage) => handlePageChange(null, newPage)}
            />
          </div>
        </div>
      </div>

      {/* Filter Modal */}
      <Modal
        title={null}
        open={openFilterPopover}
        onCancel={() => setOpenFilterPopover(false)}
        footer={null}
        width={410}
        style={{
          position: "fixed",
          top: "20px", // Add margin from top
          right: "20px", // Add margin from right
          bottom: "20px", // Add margin from bottom
          margin: 0,
          padding: 0,
          height: "calc(100vh - 40px)", // Ensure modal doesn't exceed viewport height
        }}
        bodyStyle={{ 
          padding: 0, 
          height: "100%", 
          display: "flex", 
          flexDirection: "column" 
        }}
        maskStyle={{ backgroundColor: "rgba(0, 0, 0, 0.45)" }}
        className="right-side-modal"
        closable={false}
      >
        {filterContent()}
      </Modal>

      <style>
        {`
					.even-row {
						background-color: #F9FAFB;
					}
					.odd-row {
						background-color: white;
					}
					.ant-table-cell {
						padding: 8px !important;
						font-size: 12px !important;
						height: 30px !important;
						font-family: 'Inter';
						font-weight: 400;
						line-height: 18px;
						letter-spacing: -0.1px;
						text-align: left;
						text-underline-position: from-font;
						text-decoration-skip-ink: none;
					}
					.right-side-modal .ant-modal {
						max-height: calc(100vh - 40px) !important;
						margin: 0 !important;
					}
					.right-side-modal .ant-modal-content {
						height: 100% !important;
						display: flex !important;
						flex-direction: column !important;
						border-radius: 8px !important;
						overflow: hidden !important;
					}
					.right-side-modal .ant-modal-body {
						flex: 1 !important;
						padding: 0 !important;
						overflow: hidden !important;
					}
				`}
      </style>

      <Modal
        title="Confirm Email Send"
        open={emailConfirmOpen}
        onCancel={() => handleEmailConfirmClose()}
        onOk={() => handleEmailConfirm()}
        okText="Send"
        cancelText="Cancel"
      >
        <Space direction="vertical">
          <span>
            You are about to send email
            {selectedApplicants.length > 1 ? "s" : ""} to{" "}
            {selectedApplicants.length} recipient
            {selectedApplicants.length > 1 ? "s" : ""}.
          </span>
          <div
            style={{
              backgroundColor: "#f5f5f5",
              padding: 16,
              borderRadius: 4,
            }}
          >
            <span>
              • {selectedApplicants.length} recipient
              {selectedApplicants.length > 1 ? "s" : ""} selected
            </span>
          </div>
        </Space>
      </Modal>

      {/* Confirm WhatsApp Send */}
      <Modal
        title="Confirm WhatsApp Send"
        open={whatsappConfirmOpen}
        onCancel={handleWhatsAppConfirmClose}
        onOk={handleWhatsAppConfirm}
        okText="Send"
        cancelText="Cancel"
      >
        <Space direction="vertical">
          <span>
            You are about to send WhatsApp message{selectedApplicants.length > 1 ? "s" : ""} to {selectedApplicants.length} recipient{selectedApplicants.length > 1 ? "s" : ""}.
          </span>
        </Space>
      </Modal>

      {/* Custom WhatsApp Message Modal */}
      <Modal
        title="Send Custom WhatsApp Message"
        open={customModalVisible}
        onCancel={() => setCustomModalVisible(false)}
        onOk={handleSendCustomMessage}
        okText="Send"
        cancelText="Cancel"
      >
        <AntInput.TextArea
          rows={4}
          value={customMessage}
          onChange={(e) => setCustomMessage(e.target.value)}
          placeholder="Type your message"
        />
      </Modal>

      {/* WhatsApp History Modal */}
      <Modal
        title={`WhatsApp History - ${currentCandidateForWhatsApp?.candidate_name || 'Candidate'}`}
        open={historyDialogVisible}
        onCancel={() => setHistoryDialogVisible(false)}
        footer={[
          <AntButton key="close" onClick={() => setHistoryDialogVisible(false)}>
            Close
          </AntButton>,
        ]}
        width={600}
      >
        <List
          dataSource={whatsappHistory}
          renderItem={(item) => (
            <List.Item>
              <Tag color="blue">{item.timestamp}</Tag> {item.message}
            </List.Item>
          )}
        />
      </Modal>

      <Modal
        title="Close Confirmation"
        open={openCloseConfirmation}
        onCancel={() => handleCloseConfirmation(false)}
        onOk={() => handleCloseConfirmation(true)}
        okText="Close"
        cancelText="Cancel"
        okButtonProps={{ danger: true }}
      >
        <p>
          Are you sure you want to close the application for{" "}
          <b>{selectedCandidate?.candidate_name}</b>? This action cannot be
          undone.
        </p>
      </Modal>

      <Modal
        title={`Score Details - ${
          selectedScoreInfo?.candidateName || "Candidate"
        }`}
        open={showScoreDescription}
        onCancel={() => setShowScoreDescription(false)}
        footer={[
          <AntButton key="close" onClick={() => setShowScoreDescription(false)}>
            Close
          </AntButton>,
        ]}
        width={600}
      >
        <div
          style={{
            fontFamily: "Inter",
            fontSize: "14px",
            lineHeight: "1.6",
          }}
        >
          <h3 style={{ marginTop: 0 }}>Individual Score Breakdown</h3>

          {selectedScoreInfo?.individualScores && (
            <div style={{ marginBottom: "20px" }}>
              {Object.entries(selectedScoreInfo.individualScores)
                .filter(([category]) => category !== "weighted_criterias_score")
                .map(([category, data]) => (
                  <div key={category} style={{ marginBottom: "16px" }}>
                    <h4
                      style={{
                        margin: "10px 0 5px 0",
                        fontSize: "15px",
                        fontWeight: "500",
                      }}
                    >
                      {category
                        .replace(/_/g, " ")
                        .replace(/\b\w/g, (l) => l.toUpperCase())}{" "}
                      - {data.score}/10
                    </h4>
                    <p style={{ margin: "0 0 8px 0" }}>{data.explanation}</p>
                    <div
                      style={{
                        height: "1px",
                        background: "#f0f0f0",
                        margin: "10px 0",
                      }}
                    ></div>
                  </div>
                ))}
            </div>
          )}
        </div>
      </Modal>

      {/* Edit Applicant Modal */}
      {showEditApplicant && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "flex-end",
            zIndex: 1000,
          }}
        >
          {renderEditApplicantComponent()}
        </div>
      )}

      {/* Add Remark Modal */}
      {showRemarkModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          {renderRemarkComponent()}
        </div>
      )}
    </div>
  );
};

export default Applicant;
